module.exports = __webpack_public_path__ + "img/basecamp.f4180849.svg";